import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// allow push the same router
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

/* Router Modules */
import adminRouter from './modules/admin'
import userRouter from './modules/user'

export const constantRoutes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/login')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login')
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/resetPassword')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register')
  },
  {
    path: '/re-review',
    name: 'ReReview',
    component: () => import('@/views/ReReviewPage')
  }
]

export const asyncRoutes = [
  adminRouter,
  userRouter
]

const createRouter = () => new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
